module.exports = __webpack_public_path__ + "static/staff-2-098bc6c6434d1cb8995f3e15aef15e54.png";